import { render, staticRenderFns } from "./judge-rejection-request.vue?vue&type=template&id=2c312f2c&scoped=true&"
import script from "./judge-rejection-request.vue?vue&type=script&lang=js&"
export * from "./judge-rejection-request.vue?vue&type=script&lang=js&"
import style0 from "./judge-rejection-request.vue?vue&type=style&index=0&id=2c312f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c312f2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
